// extracted by mini-css-extract-plugin
export default {"container":"CrmPage_container__xXaav","header":"CrmPage_header__L6zn+","addButton":"CrmPage_addButton__nruCK","grid":"CrmPage_grid__QZtsA"};